import React, { memo, useEffect, useReducer } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Wrapper, AirportsInputWrapper, IconWrapper } from './SimpleWay.styles';
import { AirportsSearchInput, CalendarDayPicker } from 'components/ui/controls/SearchTickets';
import { ChangeWay } from 'assets/icons';
import { objectDifference } from 'utils/diff';

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'from':
      return { ...state, from: { ...payload } };
    case 'to':
      return { ...state, to: { ...payload } };
    case 'date':
      return { ...state, date: payload };
    case 'changeWays':
      return { ...state, from: state.to, to: state.from };
    case 'state':
      return { ...payload };
    default:
      return state;
  }
};

const SimpleWay = ({ value, onChange, className, error }) => {
  const [state, dispatch] = useReducer(reducer, value);
  const { t } = useTranslation();

  useEffect(() => {
    onChange(state);
  }, [state]);

  useEffect(() => {
    if (Object.keys(objectDifference(state, value)).length) {
      dispatch({ type: 'state', payload: value });
    }
  }, [value]);

  return (
    <Wrapper className={className}>
      <AirportsInputWrapper>
        <AirportsSearchInput
          onChange={(payload) => dispatch({ type: 'from', payload })}
          error={error?.from}
          value={value?.from}
          label={t('Dashboard.Main.SearchForm.Avia.From.Label')}
          placeholder={t('Dashboard.Main.SearchForm.Avia.From.Placeholder')}
          className={'test__avia-search-form__simple__input-from'}
        />
        <AirportsSearchInput
          onChange={(payload) => dispatch({ type: 'to', payload })}
          error={error?.to}
          value={value?.to}
          label={t('Dashboard.Main.SearchForm.Avia.To.Label')}
          placeholder={t('Dashboard.Main.SearchForm.Avia.To.Placeholder')}
          className={'test__avia-search-form__simple__input-to'}
        />
        <IconWrapper onClick={() => dispatch({ type: 'changeWays' })}>
          <ChangeWay />
        </IconWrapper>
      </AirportsInputWrapper>
      <CalendarDayPicker
        error={error?.date}
        value={value?.date}
        label={t('Dashboard.Main.SearchForm.Avia.DateFrom.Label')}
        onChange={(payload) => dispatch({ type: 'date', payload })}
      />
    </Wrapper>
  );
};

SimpleWay.propTypes = {
  value: PropTypes.object,
  error: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

SimpleWay.defaultProps = {
  error: {},
};

export default styled(memo(SimpleWay))``;
